import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { AngularFireDatabase, AngularFireList } from 'angularfire2/database';
import { Todo } from '../../class/todo';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-dialog2',
  templateUrl: './dialog2.component.html',
  styleUrls: ['./dialog2.component.css']
})
export class Dialog2Component implements OnInit {

  ok: boolean = true
  reset: boolean = false

  wantOpenState: boolean = false;
  whyOpenState: boolean = false;
  difficultyOpenState: boolean = false;
  hopeOpenState: boolean = false;
  periodOpenState: boolean = false;
  challengeOpenState: boolean = false;
  achievementOpenState: boolean = false;
  colorOpenState: boolean = false;

  wantFormGroup: FormGroup;
  whyFormGroup: FormGroup;
  difficultyFormGroup: FormGroup;
  hopeFormGroup: FormGroup;
  periodFormGroup: FormGroup;
  challengeFormGroup: FormGroup;
  achievementFormGroup: FormGroup;

  backup: Todo[];
  todosRef: AngularFireList<any>;
  todoKeyRef: AngularFireList<any>;

  want:string
  why:string
  difficulty:string
  hope:string
  period:string
  challenge:string

  constructor(
    public dialogRef: MatDialogRef<Dialog2Component>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private db: AngularFireDatabase,
    private fb: FormBuilder,
  ) { 
      this.todosRef = this.db.list('todos')
      this.want = this.data.want
      this.why = this.data.why
      this.difficulty = this.data.difficulty
      this.hope = this.data.hope
      this.period = this.data.period
      this.challenge = this.data.challenge
    }

  ngOnInit() {
    this.wantFormGroup = this.fb.group({
      want: [null, Validators.required]
    });
    this.whyFormGroup = this.fb.group({
      why: [null, Validators.required]
    });
    this.difficultyFormGroup = this.fb.group({
      difficulty: [null, Validators.required]
    });
    this.hopeFormGroup = this.fb.group({
      hope: [null, Validators.required]
    });
    this.periodFormGroup = this.fb.group({
      period: [null, Validators.required]
      // completiondate: [null, Validators.required]
    });
    this.challengeFormGroup = this.fb.group({
      challenge: [null, Validators.required]
    });
    this.achievementFormGroup = this.fb.group({
      achievement: [null, Validators.required]
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  wantDateUpdate(want): void {
    this.todosRef.update(this.data.key, {
      want: want.want,
    })
    this.data.want = want.want
  }

  whyDateUpdate(why): void {
    this.todosRef.update(this.data.key, {
      why: why.why,
    })
    this.data.why = why.why
  }

  difficultyDateUpdate(difficulty): void {
    this.todosRef.update(this.data.key, {
      difficulty: difficulty.difficulty,
    })
    this.data.difficulty = difficulty.difficulty
  }

  periodDateUpdate(period): void {
    this.todosRef.update(this.data.key, {
      period: period.period,
      completiondate: period.completiondate
    })
    this.data.period = period.period
    period.completiondate
  }

  hopeDateUpdate(hope): void {
    this.todosRef.update(this.data.key, {
      hope: hope.hope,
    })
    this.data.hope = hope.hope
  }

  challengeDateUpdate(challenge): void {
    this.todosRef.update(this.data.key, {
      challenge: challenge.challenge,
    })
    this.data.challenge = challenge.challenge
  }

  redata(): void{
    this.todosRef.update(this.data.key, {
      want: this.want,
      why: this.why,
      difficulty: this.difficulty,
      period: this.period,
      hope: this.hope,
      challenge: this.challenge,
    })
    this.data.want = this.want
    this.data.why = this.why
    this.data.difficulty = this.difficulty
    this.data.period = this.period
    this.data.hope = this.hope
    this.data.challenge = this.challenge
  }

}


// WEBPACK FOOTER //
// C:/Users/homePC/angular-comp/yarukami/src/app/dashboad/dialog2/dialog2.component.ts